// extracted by mini-css-extract-plugin
export default {"listaTarefas":"Lista_listaTarefas__GJlLi"};